gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.faqs-section__anchor').forEach(function (el) {
  var id = el.getAttribute('id');
  var title = el.getAttribute('data-title');
  var item = document.createElement('li');
  var link = document.createElement('a');
  var span = document.createElement('span');
  link.href = `#${id}`;
  span.innerText = title;
  link.appendChild(span);
  item.appendChild(link);
  document.querySelector('.faqs-section__menu').appendChild(item);
});

$('.faq-category__toggle').on('click', function () {
  var $target = $(this).closest('.faq-main');
  $('.faq-main.active').not($target).removeClass('active');
  $target.toggleClass('active');
});

$('.faqs-section__menu li a').on('click', function () {
  $('.faqs-section__menu li a.active').removeClass('active');
  $(this).toggleClass('active');
});

ScrollTrigger.matchMedia({
  '(min-width: 767px)': function () {
    var offset = $('.header').height() + 30;
    // const offsetBottom = $('.faq-main__tab-links').height() + offset + 100;

    var ST = ScrollTrigger.create({
      trigger: '.faqs-section__col--sticky',
      endTrigger: '.footer',
      start: `${-(110 + 30 + $('.header').height())} top`,
      end: 'top bottom',
      pin: true,
      pinSpacing: false,
    });
  },
});
